/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AcceptOfferResponseOrder } from './AcceptOfferResponseOrder';

export type AcceptOfferResponse = {
    outcome: AcceptOfferResponse.outcome;
    order?: AcceptOfferResponseOrder;
};

export namespace AcceptOfferResponse {

    export enum outcome {
        SUCCESS = 'success',
        EXPIRED = 'expired',
        UNAUTHORIZED = 'unauthorized',
    }


}

